<template>
  <div id="app">
    <div class="header">
      <div>
        <el-row type="flex" justify="space-between">
          <!-- 左侧 logo -->
          <div class="index-logo" style="display: flex;">
            <router-link to="/">
              <img src="../static/image/logo.jpg"/>
            </router-link>
            <img src="../static/image/divider.png" style="height: 50px; width: 50px; position: relative; top: 20px;"  v-show="isPhone == false">
            <div>
              <p style="font-size: 25px; font-weight: bold; margin: 0;"  v-show="isPhone == false">
                澳岚丁生物科技有限公司
              </p>
            </div>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="paySuccessfully"
            width="50%"
            height="60%"
            center>
            <div style="text-align: center;">
                <img src="../static/image/paySuccessfully.png" style="width: 150px; height: 150px;" />
                <h3>支付成功！已发送相关邮件至您的邮箱，注意查收。</h3>
                <!-- <div>
                    <h4>支付成功！</h4>
                </div> -->
            </div>
          </el-dialog>

          <el-drawer
            title="您选购的内容"
            :visible.sync="drawer">
          </el-drawer>

          <el-dialog
            title="您的购物车"
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            width="50%"
            height="60%"
            center>
            <el-table
              :data="tableData"
              element-loading-text="Loading"
              border
              fit
              highlight-current-row
              @selection-change="handleSelectionChange"
              style="width: 100%; color: black;">
              <el-table-column
                type="selection"
                width="55">
              </el-table-column>
              <el-table-column
                prop="productName"
                label="产品名称"
                width="220">
              </el-table-column>
              <el-table-column
                prop="chooseType"
                label="选择规格"
                width="160">
              </el-table-column>
              <el-table-column
                prop="chooseCount"
                label="数量"
                width="120">
              </el-table-column>
              <el-table-column
                prop="price"
                label="价格(元)"
                width="120">
              </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="scope">
                  <el-button type="danger" plain @click="deleteFromCartItem(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <h4>总计：{{ totalPrice }}元</h4>
            <span slot="footer" class="dialog-footer">
              <el-button @click="toAliPay">购买</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="订单记录"
            :visible.sync="ordersRecordDialogVisible"
            width="50%"
            height="60%"
            center>
            <el-radio-group v-model="ordersRecordStatus">
              <el-radio-button label="已支付"></el-radio-button>
              <el-radio-button label="待支付"></el-radio-button>
            </el-radio-group>
            <el-table
              :data="ordersRecordTableData"
              element-loading-text="Loading"
              v-show="ordersRecordStatus =='已支付'"
              border
              fit
              highlight-current-row
              style="width: 100%; color: black;">
              <el-table-column
                prop="desc"
                label="订单内容"
                width="300">
              </el-table-column>
              <el-table-column
                prop="price"
                label="订单价格(元)"
                width="120">
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="订单创建时间"
                width="180">
              </el-table-column>
              <el-table-column
                prop="payTime"
                label="订单支付时间">
              </el-table-column>
            </el-table>
            <el-table
              :data="ordersRecordTableData"
              element-loading-text="Loading"
              v-show="ordersRecordStatus =='待支付'"
              border
              fit
              highlight-current-row
              style="width: 100%; color: black;">
              <el-table-column
                prop="desc"
                label="订单内容"
                width="300">
              </el-table-column>
              <el-table-column
                prop="price"
                label="订单价格(元)"
                width="120">
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="订单创建时间"
                width="160">
              </el-table-column>
              <el-table-column
                label="操作"
                >
                <template slot-scope="scope">
                  <el-button type="success" plain @click="payInRecord(scope.row.id)">支付</el-button>
                  <el-button type="danger" plain @click="deleteOrdersInRecord(scope.row.id)">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div id="page" style="text-align: center;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="ordersRecordCurrentPage"
                :page-sizes=ordersRecordPageSizes
                :page-size=ordersRecordPageSize
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="ordersRecordTotalCount">
              </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
            </span>
          </el-dialog>
          
          <el-dialog
            title="登录"
            :visible.sync="this.$store.state.loginDialogVisiable"
            width="50%"
            height="60%"
            :before-close="closeLoginDialog"
            center>
            <div style="">
              <el-input v-model="loginData.username" style="width: 47.5%;" placeholder="用户名" class="rounded-input" maxlength="10" show-word-limit />
              <el-input v-model="loginData.password" style="width: 47.5%;" placeholder="密码" class="rounded-input" show-password maxlength="10" show-word-limit />
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="login" type="primary">确 认</el-button>
              <el-button @click="openRegisterDialog">去注册</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="注册"
            :visible.sync="this.$store.state.registerDialogVisiable"
            width="50%"
            height="60%"
            :before-close="closeRegisterDialogVisiable"
            center>
            <div style="">
              <el-input v-model="registerData.username" placeholder="用户名" style="width: 47.5%;" class="rounded-input" maxlength="10" show-word-limit />
              <el-input v-model="registerData.password" placeholder="密码" style="width: 47.5%;" class="rounded-input" show-password maxlength="10" show-word-limit />
              <el-input v-model="registerData.passwordConfirm" placeholder="确认密码" style="width: 47.5%;" class="rounded-input" show-password maxlength="10" show-word-limit />
              <el-input v-model="registerData.email" placeholder="您的邮箱账户" style="width: 47.5%;" class="rounded-input" maxlength="50" show-word-limit />
              <el-input v-model="registerData.verifiedCode" placeholder="您的邮箱验证码" style="width: 47.5%;" class="rounded-input" maxlength="4" show-word-limit />
              <el-input v-model="registerData.phone" placeholder="您的手机号码" style="width: 47.5%;" class="rounded-input" maxlength="50" show-word-limit />
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="register">提 交</el-button>
              <el-button type="primary" @click="getVerifiedCode">获取邮箱验证码</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="修改密码"
            :visible.sync="changePasswordVisiable"
            width="50%"
            height="60%"
            center>
            <div style="">
              <el-input v-model="changePasswordData.password" placeholder="新密码" class="rounded-input" show-password maxlength="10" show-word-limit />
              <el-input v-model="changePasswordData.passwordConfirm" placeholder="确认密码" class="rounded-input" show-password maxlength="10" show-word-limit />
              <el-input v-model="changePasswordData.verifiedCode" placeholder="您的邮箱验证码" class="rounded-input" maxlength="4" show-word-limit />
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitChangePassword">提 交</el-button>
              <el-button type="primary" @click="getChangePwdVerifiedCode">获取邮箱验证码</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="填写您的联系方式"
            :visible.sync="messageDialogVisible"
            width="50%"
            height="60%"
            center>
            <div style="">
              <el-input v-model="dataMap.name" placeholder="您的姓名" class="rounded-input" />
              <el-input v-model="dataMap.email" placeholder="您的Email" class="rounded-input" />
              <el-input v-model="dataMap.phone" placeholder="您的电话" class="rounded-input" />
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="toPay">确认提交</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="您的收货地址"
            :visible.sync="receiveAddressVisible"
            width="70%"
            height="60%"
            center>
            <div style="">
              <el-descriptions class="margin-top" title="收货地址" :column="3" :size="size" border>
                <template slot="extra">
                  <!-- <el-button type="primary" size="small"></el-button> -->
                </template>
                <!-- <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-user"></i>
                    用户名
                  </template>
                  {{ loginData.username }}
                </el-descriptions-item> -->
                <!-- <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-mobile-phone"></i>
                    手机号
                  </template>
                  <el-input v-model="input"></el-input>
                </el-descriptions-item> -->
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    居住省(直辖市)
                  </template>
                  <div @click="jy">
                    <el-select v-model="addressProvince" placeholder="请选择" @change="jy">
                      <el-option
                        v-for="item in provinceData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    居住市
                  </template>
                  <el-select v-model="addressCity" placeholder="请选择" :disabled="directCity.includes(addressProvince)" @change="jy">
                    <el-option
                      v-for="item in cityData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    居住区
                  </template>
                  <el-select v-model="addressArea" placeholder="请选择" @change="jy"> 
                    <el-option
                      v-for="item in areaData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-descriptions-item>
                <!-- <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-tickets"></i>
                    备注
                  </template>
                  <el-tag size="small">学校</el-tag>
                </el-descriptions-item> -->
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-office-building"></i>
                    详细地址
                  </template>
                  <el-input v-model="addressToil" ></el-input>
                </el-descriptions-item>
              </el-descriptions>
              <br/>
              <h3>注:江浙沪 10 其余地区 20 新疆等偏远地区 50</h3>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="setAddress">确认</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="上传您的新头像"
            :visible.sync="changeAvatarVisible"
            width="30%"
            center
            :before-close="handleAvatarDialogClose">
                      <el-upload
                          class="avatar-uploader"
                          :action="changeAvatarUrl"
                          :show-file-list="false"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload"
                          style="
                            text-align: center;
                            position: relative;
                          ">
                          <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width: 250px;height: 250px;">
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitChangeAvatar">确 定</el-button>
            </span>
          </el-dialog>

          <!-- <div class="dropdown-container" @click="toggleMenu">
            <div class="dropdown-trigger" v-show="isPhone == true">
              <i class="menu-icon">☰</i>
            </div>

            <div v-show="menuVisible == true" class="dropdown-menu" :class="{ 'is-mobile': isMobile }">
              <a href="/" class="dropdown-item">首页</a>
              <a href="/solution" class="dropdown-item">技术服务</a>
              <a href="/product" class="dropdown-item">产品信息</a>
              <a href="/contactUs" class="dropdown-item">联系我们</a>
            </div>
          </div> -->

          <!-- <button @click="openDialog" class="buy-button">购买</button> -->
          <!-- 菜单部分 -->
          <el-menu
            :default-active="activeIndex"
            :active-text-color="activeColor"
            :router="true"
            class="el-menu-demo menu-right"
            mode="horizontal"
            v-show="isPhone == false"
            @select="handleSelect">
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/solution">技术服务</el-menu-item>
            <el-menu-item index="/product">产品信息</el-menu-item>
            <el-menu-item index="/contactUs">联系我们</el-menu-item>
            <span>&nbsp;</span>
            <!-- <div style="position: relative; display: inline-block; top: -10%;">
              <img src="./assets/login.png" style="height: 40px; width: 60px;" @click="openLoginDialog" v-show="isLogin()">
              <el-tooltip class="item" effect="dark" :content="loginData.username" placement="right-end">
                <el-dropdown trigger="click">
                  <img :src="imgUrl" style="height: 60px; width: 60px; border-radius: 50%; overflow: hidden;" v-show="!isLogin()">
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item divided @click.native="logout">
                      退出登录
                    </el-dropdown-item>
                    <el-dropdown-item divided @click.native="ordersRecord">
                      您的订单
                    </el-dropdown-item>
                    <el-dropdown-item divided @click.native="receiveAddress">
                      收货地址
                    </el-dropdown-item>
                    <el-dropdown-item divided @click.native="changePassword">
                      修改密码
                    </el-dropdown-item>
                    <el-dropdown-item divided @click.native="editAvatar">
                      编辑头像
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-tooltip>
            </div> -->

            <!-- <div style="position: relative; display: inline-block;">
              <img src="./assets/login.png" style="height: 40px; width: 60px;" @click="openLoginDialog">
              <span v-if="cartItemCount > 0"
                  style="position: absolute; top: -10px; right: -10px; color: skyblue; font-size: 12px; font-weight: bold;">
                  {{ cartItemCount }}
              </span>
            </div> -->
            
            <!-- <el-badge :value="100" :max="10" class="item">
              <el-tooltip class="item" effect="dark" content="购物车" placement="right-end">
                  <img src="./assets/shopCar.png" style="height: 30px; width: 30px;padding-top: 0%;" @click="drawer = true">
              </el-tooltip>
            </el-badge> -->
            <!-- <div class="fixed-button">
              <img src="./assets/shopCar.png" style="height: 120px; width: 120px;" @click="openDialog">
              <span v-if="cartItemCount > 0"
                  style="position: absolute; top: -10px; right: -10px; color: skyblue; font-size: 12px; font-weight: bold;">
                  {{ cartItemCount }}
              </span>
              <h4 style="position: relative; left: 40%;top: -20px;">购物车</h4>
            </div> -->
          </el-menu>  
        </el-row>
      </div>
    </div>

    <div :class="['main-content',{'pdb0':activeIndex == '/contactUs'}]">
      <router-view :class="[activeIndex == '/contactUs'?'':'content']"></router-view>
    </div>
    <Footer v-if="activeIndex != '/contactUs'"></Footer>
  </div>
</template>

<script>
import Footer from './components/footer/Footer';
import ElCol from "element-ui/packages/col/src/col";
import { getAvatarUrl, submitChangeAvatarUrl, deleteAvatarUrl, uploadAvatarUrl, avatarUrl, getIpInfo, getLoginUrl, getRegisterUrl, getShopCarUrl, getDeleteShopCarUrl, getAddOrdersUrl, getAlipayUrl, homePage, getVerifiedCodeUrl, getChangePwdVerifiedCodeUrl, getChangePasswordUrl, getOrdersRecordTableDataUrl, getDeleteOrdersUrl, getProvinceDataUrl, getBelongDataUrl, getByUsernameUrl, getAddReceiveAddressUrl } from './request/request';
import { deepCopy } from './utils/index';
import { deleteProductById } from './utils/index';
import { isMobile } from './utils/index';
import request from "superagent";

export default {
  name: 'App',
  data() {
    return {
      size: '',
      isClear: false,
      directCity: ['北京市','上海市','天津市','重庆市'],
      addressProvince: '',
      provinceData: [],
      addressCity: '',
      cityData: [],
      addressArea: '',
      areaData: [],
      addressToil: '',
      receiveAddressVisible: false,
      menuVisible: false,  // 控制菜单显示与隐藏
      isMobile: false,     // 判断是否为移动端
      activeIndex: '',
      activeColor: '#409EFF',
      mobile_nav: false,
      drawer: false,
      cartItemCount: 0,
      dialogVisible: false,
      tableData: [],
      totalPrice: 0,
      messageDialogVisible: false,
      dataMap: {
        name: '',
        email: '',
        phone: '',
      },
      //浅拷贝复制对象
      copyVal: [],
      loginData: {
        username: '',
        password: ''
      },
      registerData: {
        username: '',
        password: '',
        passwordConfirm: '',
        email: '',
        verifiedCode: '',
        phone: '',
      },
      changePasswordData: {
        password: '',
        passwordConfirm: '',
        verifiedCode: ''
      },
      changePasswordVisiable: false,
      ordersRecordDialogVisible: false,
      ordersRecordTableData: [],
      ordersRecordStatus: '已支付',
      ordersRecordCurrentPage: 1,
      ordersRecordTotalCount: 1,
      ordersRecordPageSizes:[5,10],
      // 每页显示的条数
      ordersRecordPageSize:5,
      paySuccessfully: false,
      changeAvatarVisible: false,
      imageName: '',
      imageUrl: '',
      changeAvatarUrl: '',
      imgUrl: '',
      isPhone: false,
    };
  },
  components: {
    ElCol, Footer
  },
  methods: {
    // async fetchProvinceData() {
    //   try {
    //     const res = await request.get(`${getProvinceDataUrl()}`);
    //     this.provinceData = res.body.data;
    //   } catch (err) {
    //     console.error('Error fetching province data:', err);
    //   }
    // },
    jy(){
      this.isClear = true;
    },
    setAddress(){
      if(this.addressProvince == '' || this. addressArea == '' || this.addressToil == ''){
        this.$notify({
          title: '提示',
          message: '请填写完毕后提交！',
          type: 'warning'
        });
        return;
      }
      request.post(`${getAddReceiveAddressUrl()}`)
      .send({
        username: sessionStorage.getItem('username'),
        addressProvince: this.addressProvince,
        addressCity: this.addressCity,
        addressArea: this.addressArea,
        addressToil: this.addressToil,
      }).end((err,res) => {
        console.log(res);
        console.log(err);
        this.$notify({
          title: '提示',
          message: '编辑成功！',
          type: 'success'
        });
      })
    },
    receiveAddress(){
      // await this.fetchProvinceData();
      request.get(`${getProvinceDataUrl()}`)
      .end((err,res) => {
        this.provinceData = res.body.data;
      });
      request.get(`${getByUsernameUrl()}?username=${sessionStorage.getItem('username')}`)
      .end((err,res) => {
        if(res.body.code == 1){
          this.isClear = false;
          this.addressProvince = res.body.data.addressProvince;
          this.addressCity = res.body.data.addressCity;
          this.addressArea = res.body.data.addressArea;
          this.addressToil = res.body.data.addressToil;
        }
      });
      this.receiveAddressVisible = true;
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    checkDevice() {
      // 判断设备类型，超过768px为PC端，反之为移动端
      this.isMobile = window.innerWidth <= 768;
    },
    submitChangeAvatar(){
      if(this.imageName == ''){
        this.$message.error("请选择图片上传！");
        return;
      }
      request.get(`${submitChangeAvatarUrl}?username=${sessionStorage.getItem('username')}&avatarName=${this.imageName}`)
      .end((err,res) => {
        console.log(res);
        this.$message.success("编辑成功！");
        this.imgUrl = avatarUrl + this.imageName;
        console.log(this.imageUrl);
        this.changeAvatarVisible = false;
        this.imageName = '';
        this.imageUrl = '';
      });
    },
    handleAvatarDialogClose(){
      if(this.imageName!=''){
        request.get(`${deleteAvatarUrl}?imageName=${this.imageName}`)
        .end((err,res) =>{
          console.log('delete image ...');
        });
      }
      this.changeAvatarVisible = false;
      this.imageName = '';
      this.imageUrl = '';
    },
    beforeAvatarUpload(file){
      if(parseFloat(file.size/1024/1024)>=parseFloat(5)){
        this.$message.error("上传的新头像应小于5MB喔");
        reject();
      }
      if(this.imageName != ''){
        request.get(`${deleteAvatarUrl}?imageName=${this.imageName}`)
        .end((err,res) =>{
          console.log('delete image ...');
        });
      }
    },
    // 成功上传之后拿到返回回来的文件名
    handleAvatarSuccess(res) {
      let code = res.code;
      console.log(code);
      let data = res.data;
      console.log(data);
      let msg = res.msg;
      if(code == 1){
        this.imageName = data;
        this.imageUrl = avatarUrl + this.imageName;
        console.log(this.imageName);
        console.log(this.imageUrl);
        this.$message.success('上传成功！');
        return;
      }
      if(code == 0){
        this.$message.error(msg);
      }
    },
    deleteOrdersInRecord(id){
      request.get(`${getDeleteOrdersUrl()}?ordersId=${id}`)
      .end((err,res) =>{
        this.$notify({
          title: '提示',
          message: res.body.data,
          type: 'success'
        });
        this.getOrdersRecordTableData();
      });
    },
    payInRecord(id){
      const newWindow = window.open(''); // 打开一个新窗口
      newWindow.location.href = `${getAlipayUrl()}?ordersId=${id}`;
      this.ordersRecordDialogVisible = false;
    },
    getOrdersRecordTableData(){
      request.get(`${getOrdersRecordTableDataUrl()}?username=${sessionStorage.getItem('username')}&status=${this.ordersRecordStatus}&page=${this.ordersRecordCurrentPage}&pageSize=${this.ordersRecordPageSize}`)
      .end((err,res) => {
        let data = res.body.data.records;
        for (const key in data) {
          if (typeof data[key] === 'string' && !isNaN(data[key])) {
            data[key] = Number(data[key]);
          }
        }
        this.ordersRecordTableData = data;
        let count = res.body.data.total;
        this.ordersRecordTotalCount = Number(count);
      });
    },
    handleSizeChange(pageSize) {
      this.ordersRecordPageSize = pageSize;
      this.getOrdersRecordTableData();
    },
    handleCurrentChange(currentPage) {
      this.ordersRecordCurrentPage = currentPage;
      this.getOrdersRecordTableData();
    },
    ordersRecord(){
      this.getOrdersRecordTableData();
      this.ordersRecordDialogVisible = true;
    },
    editAvatar(){
      // this.$notify({
      //   title: '提示',
      //   message: '暂未开放！',
      //   type: 'warning'
      // });
      this.changeAvatarVisible = true;
    },
    getChangePwdVerifiedCode(){
      request.get(`${getChangePwdVerifiedCodeUrl()}?username=${sessionStorage.getItem('username')}`)
      .end((err,res) => {
        if(err){
          console.log(err);
        } else {
          if(res.body.code == 0){
            this.$notify.error({
              title: '提示',
              message: res.body.msg
            });
            return;
          }
          this.$notify({
            title: '提示',
            message: res.body.data,
            type: 'success'
          });
        }
      })
    },
    submitChangePassword(){
      if(this.changePasswordData.password == '' || this.changePasswordData.passwordConfirm == ''){
        this.$notify.error({
          title: '提示',
          message: '请输入密码!'
        });
        return;
      }
      if(this.changePasswordData.password != this.changePasswordData.passwordConfirm){
        this.$notify.error({
          title: '提示',
          message: '两次密码不一致!'
        });
        return;
      }
      if(this.changePasswordData.verifiedCode == ''){
        this.$notify.error({
          title: '提示',
          message: '请输入验证码！'
        });
        return;
      }
      request.post(`${getChangePasswordUrl()}?username=${sessionStorage.getItem('username')}`)
      .send(this.changePasswordData)
      .end((err,res) => {
        if(err){
          console.log(err);
        } else {
          if(res.body.code == 0){
            this.$notify.error({
              title: '提示',
              message: res.body.msg
            });
            return;
          }
          this.$notify({
            title: '提示',
            message: res.body.data,
            type: 'success'
          });
          this.changePasswordVisiable = false;
        }
      });
    },
    changePassword(){
      this.changePasswordVisiable = true;
    },
    getVerifiedCode(){
      if(this.registerData.email == ''){
        this.$notify.error({
          title: '提示',
          message: '请输入邮箱账号再获取验证码!'
        });
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(emailRegex.test(this.registerData.email) == false){
        this.$notify.error({
          title: '提示',
          message: '请填写格式正确的邮箱账号!'
        });
        return;
      }
      let ipInfo = JSON.parse(sessionStorage.getItem('ipInfo'));
      // console.log(ipInfo.ip);
      request.get(`${getVerifiedCodeUrl()}?ip=${ipInfo.ip}&email=${this.registerData.email}`)
      .end((err,res) => {
        if(err){
          console.log(err);
        } else {
          if(res.body.code == 0){
            this.$notify.error({
              title: '提示',
              message: res.body.msg
            });
            return;
          }
          this.$notify({
            title: '提示',
            message: res.body.data,
            type: 'success'
          });
        }
      })
    },
    logout(){
      sessionStorage.removeItem('ipInfo');
      sessionStorage.removeItem('username');
      location.href = homePage;
      console.log('logout...');
    },
    toAliPay(){
      if(this.tableData.length == 0 || this.totalPrice == 0){
        this.$notify({
          title: '提示',
          message: '请选择需要购买的产品！',
          type: 'warning'
        });
        return;
      }
      
      // this.copyVal.forEach((value,index,array) => {
      //   console.log(value);
      // });
      request.post(`${getAddOrdersUrl()}?username=${sessionStorage.getItem('username')}&price=${this.totalPrice}`)
        .send(this.copyVal)
        .end((err, res) => {
          if(res.body.code == 0){
            this.$notify({
              title: '提示',
              message: res.body.msg,
              type: 'warning'
            });
            return;
          }
          const newWindow = window.open(''); // 打开一个新窗口
          newWindow.location.href = `${getAlipayUrl()}?ordersId=${res.body.data.id}`; // 更新新窗口的 URL
      });
      this.dialogVisible = false;
    },
    toMessageDialog(){
      if(this.tableData.length == 0 || this.totalPrice == 0){
        this.$notify({
          title: '提示',
          message: '请选择需要购买的产品！',
          type: 'warning'
        });
        return;
      }
      this.dataMap.name = '';
      this.dataMap.email = '';
      this.dataMap.phone = '';
      this.messageDialogVisible = true;
    },
    handleSelect(val){
    },
    mobileNav(){
      this.mobile_nav = !this.mobile_nav
    },
    getPath(){
      this.activeIndex = this.$route.path
    },
    goLogin(url,opt_label){
      window.open(url)
      _hmt.push(['_trackEvent', 'login', 'click', opt_label])
    },
    openDialog(){
      if(this.isLogin() == true){
        this.$notify({
          title: '提示',
          message: '请登录您的账号！',
          type: 'warning'
        });
        this.$store.commit('updateLoginDialogVisiable',true);
        return;
      }
      request.get(`${getShopCarUrl()}?username=${sessionStorage.getItem('username')}`)
      .end((err,res) => {
        if(err){
          console.log(err);
        } else {
          if(res.body.code == 0){
            this.$notify.error({
              title: '提示',
              message: res.body.msg
            });
            return;
          }
          this.tableData = res.body.data;
        }
      });
      this.dialogVisible = true;
    },
    handleClose(){
      this.dialogVisible = false;
      console.log('close dialog...');
    },
    handleSelectionChange(val) {
      let totalPrice = val.reduce((total, product) => {
        return total + product.price;
      }, 0); // 0 是累加的初始值
      this.totalPrice = totalPrice;
      this.copyVal = deepCopy(val);
    },
    deleteFromCartItem(id){
      request.get(`${getDeleteShopCarUrl()}?id=${id}`)
      .end((err,res) => {
        if(err){
          console.log(err);
        } else {
          if(res.body.code == 0){
            this.$notify.error({
              title: '提示',
              message: res.body.msg
            });
            return;
          }
          this.$notify({
            title: '提示',
            message: res.body.data,
            type: 'success'
          });
          request.get(`${getShopCarUrl()}?username=${sessionStorage.getItem('username')}`)
          .end((err,res) => {
            if(err){
              console.log(err);
            } else {
              if(res.body.code == 0){
                this.$notify.error({
                  title: '提示',
                  message: res.body.msg
                });
                return;
              }
              this.tableData = res.body.data;
            }
          });
        }
      })
      // let cartItem = deleteProductById(id,this.$store.state.cartItem);
      // this.$store.commit('updateCartItem',cartItem);
      // this.$store.commit('updateCartItemCount',cartItem.length);
    },
    hasEmptyOrNull(data) {
      console.log(data);
      let returnMessage = '';
      for (let key in data) {
        if (data[key] === '' || data[key] === null) {
          returnMessage = '请填写完毕内容再提交!';
          return returnMessage;
        }
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(emailRegex.test(data.email) == false){
        returnMessage = returnMessage + '请填写正确的邮箱账号!';
        return returnMessage;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if(phoneRegex.test(data.phone) == false){
        returnMessage = returnMessage + '请填写正确的电话号码!';
        return returnMessage;
      }
      if(data.password != data.passwordConfirm){
        returnMessage = returnMessage + '两次密码不一致';
        return returnMessage;
      }
      return returnMessage;
    },
    toPay(){
      let message = this.hasEmptyOrNull(this.dataMap);
      if(message != ''){
        this.$notify({
          title: '提示',
          message: message,
          type: 'warning',
        });
        return;
      }
    },
    openLoginDialog(){
      this.loginData.username = '';
      this.loginData.password = '';
      this.$store.commit('updateLoginDialogVisiable',true);
    },
    closeLoginDialog(){
      this.$store.commit('updateLoginDialogVisiable',false);
    },
    login(){
      if(this.loginData.username == '' || this.loginData.password == ''){
        this.$notify.error({
          title: '错误',
          message: '请填写完内容在提交！'
        });
        return;
      }
      request.post(`${getLoginUrl()}`).send({
        loginData: this.loginData,
      }).end((err, res) => {
        if(err){
          console.log(err);
        } else {
          if(res.body.code == 0){
            this.$notify.error({
              title: '提示',
              message: res.body.msg
            });
            return;
          }
          this.$notify({
            title: '提示',
            message: res.body.data,
            type: 'success'
          });
          sessionStorage.setItem('username',this.loginData.username);
          this.$store.commit('updateLoginDialogVisiable',false);
        }
      });
    },
    isLogin(){
      if(sessionStorage.getItem('username') == null || sessionStorage.getItem('username') == undefined){
        this.imgUrl = require('./assets/touXiang.png');
        return true;
      }
      request.get(`${getAvatarUrl}?username=${sessionStorage.getItem('username')}`)
      .end((err,res) => {
        let name = res.body.data;
        if(name == 'default'){
          this.imgUrl = require('./assets/touXiang.png');
        } else {
          this.imgUrl = avatarUrl + name;
        }
      });
      return false;
    },
    openRegisterDialog(){
      this.$store.commit('updateLoginDialogVisiable',false);
      this.$store.commit('updateRegisterDialogVisiable',true);
    },
    closeRegisterDialogVisiable(){
      this.$store.commit('updateRegisterDialogVisiable',false);
    },
    register(){
      let message = this.hasEmptyOrNull(this.registerData);
      if(message != ''){
        this.$notify.error({
          title: '提示',
          message: message
        });
        return;
      }
      let ipInfo = JSON.parse(sessionStorage.getItem('ipInfo'));
      request.post(`${getRegisterUrl()}?ip=${ipInfo.ip}`).send({
        registerData: this.registerData
      }).end((err,res) => {
        if(err){
          console.log(err);
        } else {
          if(res.body.code == 0){
            this.$notify.error({
              title: '提示',
              message: res.body.msg
            });
            return;
          }
          this.$notify({
            title: '提示',
            message: res.body.data,
            type: 'success'
          });
          this.$store.commit('updateRegisterDialogVisiable',false);
        }
      });
    }
  },
  created(){
    this.activeIndex =this.$route.path
  },
  watch: {
    '$route':'getPath',
    // '$store.state.cartItemCount'(newValue,oldValue){
    //   this.cartItemCount = newValue;
    // },
    // '$store.state.cartItem'(newValue,oldValue){
    //   this.tableData = newValue;
    // },
    ordersRecordStatus(newValue,oldValue){
      this.getOrdersRecordTableData();
    },
    addressProvince(newValue,oldValue){
      if(this.isClear == true){
        this.addressCity = '';
        this.addressArea = '';
        this.addressToil = '';
      }
      request.get(`${getBelongDataUrl()}?name=${newValue}`)
      .end((err,res) => {
        if(this.directCity.includes(newValue)){
          this.areaData = res.body.data;
        } else{
          this.cityData = res.body.data;
        }
      });
    },
    addressCity(newValue,oldValue){
      if(this.isClear == true){
        this.addressArea = '';
        this.addressToil = '';
      }
      request.get(`${getBelongDataUrl()}?name=${newValue}`)
      .end((err,res) => {
        this.areaData = res.body.data;
      });
    },
    addressArea(newValue,oldValue){
      if(this.isClear == true){
        this.addressToil = '';
      }
    }
  },
  mounted(){
    getIpInfo();
    this.loginData.username = sessionStorage.getItem('username') == null || sessionStorage.getItem('username') == undefined ? '' : sessionStorage.getItem('username');
    // console.log();
    let url = location.href;
    if(url.includes('?pay_successfully')){
      this.paySuccessfully = true;
    }
    this.changeAvatarUrl = uploadAvatarUrl;
    this.isPhone = isMobile();
    console.log(this.isPhone);
    // this.cartItemCount = this.$store.state.cartItemCount;
    // this.tableData  = this.$store.state.cartItem;
  }
}
</script>

<style lang="less">

.dropdown-container {
  position: relative;
  display: inline-block;
}

/* 触发按钮（图标）样式 */
.dropdown-trigger {
  cursor: pointer;
  font-size: 24px;
  padding: 10px;
  border-radius: 5px;
  background-color: #f5f5f5;
}

.menu-icon {
  font-size: 40px; /* 图标大小 */
}

/* 下拉菜单的基本样式 */
.dropdown-menu {
  position: absolute;
  top: 80px;
  left: -20px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 400px;
  display: block;
  z-index: 9999;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.3s ease;
}

/* 下拉菜单项样式 */
.dropdown-item {
  display: block;
  padding: 10px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #ddd;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

/* 针对移动端样式 */
.dropdown-menu.is-mobile {
  width: 100%; /* 移动端占满宽度 */
}

/* 动画效果 */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


.fixed-button {
  position: fixed;
  top: 85%; /* 页面垂直居中的位置 */
  right: 60px; /* 距离页面右侧 20px */
  transform: translateY(-50%); /* 保证按钮在垂直方向正中间 */
  z-index: 1000; /* 保证按钮在最上层 */
}

.fixed-button button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.fixed-button button:hover {
  background-color: #0056b3;
}

.rounded-input {
  margin-bottom: 10px; /* 设置下边距 */
  border-radius: 50px; /* 你可以根据需要调整这个值 */
  width: 380px;
}

.item {
  margin-top: 10px;
  margin-right: 0px;
}


.index-logo {
  margin-left: 60px; /* 左侧空出20px */
}
.menu-right {
  margin-left: auto; /* 将菜单推向右侧 */
  padding-right: 80px; /* 右边空出 50px */
}


.el-menu-demo {
  margin: 0; /* 确保菜单与其他元素的间距为 0 */
}

  @import "style/common.less";
</style>



// WEBPACK FOOTER //
// src/App.vue